import { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";

export const PurchaseItemForm = ({
  onCancel,
  productionRefetch,
  purchaseRefetch,
}) => {
  const [form] = Form.useForm();
  const { id } = useParams();

  const postUrl =
    id && `${process.env.REACT_APP_API_URL}/api/purchases/${id}/items/`;
  const prepurchasedUrl = `${process.env.REACT_APP_API_URL}/api/giftcards/?limit=10000&sort_by=GiftCardName&order=asc&page=1`;

  const { data: prepurchasedData, loading: prepurchasedLoading } =
    useGet(prepurchasedUrl);
  const prepurchasedOptions =
    prepurchasedData?.data?.map((item) => ({
      label: item.GiftCardName,
      value: item.GiftCardNo,
    })) ?? [];

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    const modValues = {
      GiftCardNo: Number(values.GiftCardNo),
      ItemCount:
        values.ItemCount != null ? Number(values.ItemCount) : undefined,
    };
    try {
      await postAction(modValues);
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ItemCount: 10,
    });
  }, []);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoading && !postError && postData) {
      productionRefetch();
      purchaseRefetch?.();
      onCancel();
      openConfirmNotification("Success");
    }
  }, [postError, postData, postLoading]);

  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div className={`px-2 pt-0 pb-3`}>
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <CustomSelect
                label="Prepurchased License"
                name="GiftCardNo"
                options={prepurchasedOptions}
                placeholder="Please select"
                required
                loading={prepurchasedLoading}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <CustomInput label="Item Count" name="ItemCount" type="number" />
            </Col>
          </Row>
        </div>
      </Form>

      <div className="flex justify-center space-x-2 mt-2.5">
        <Button
          type="primary"
          className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
          onClick={() => form.submit()}
          loading={postLoading}
          disabled={postLoading}
        >
          <CheckCircleOutlined className="!text-[14px] font-medium" />
          <span className="">Apply</span>
        </Button>
        <Button className="reset-button" onClick={onCancel}>
          <CloseOutlined />
          <span className="">Cancel</span>
        </Button>
      </div>
    </>
  );
};
